<template>
  <div class="evaluate">
    <mt-header title="申请成功">
      <mt-button slot="right">完成</mt-button>
    </mt-header>
    <div class="content">
      <div class="title">
        <h1>{{projecttitle}}</h1>
        <p>我给 > <span>{{suppliername}}</span>评价</p>
      </div>
      <div class="star">
        <div>
          <span>准时率</span><star-rating :item-size=16 :increment=0.5 v-model="ratingOne" :show-rating="false" @click.native="punctualityRate"></star-rating>
        </div>
        <div>
          <span>完成质量</span><star-rating :item-size=16 :increment=0.5 v-model="ratingTwo" :show-rating="false" @click.native="completionQuality"></star-rating>
        </div>
        <div>
          <span>满意度</span><star-rating :item-size=16 :increment=0.5 v-model="ratingThree" :show-rating="false" @click.native="satisfactionRate"></star-rating>
        </div>
      </div>
      <div class="label">
        <span v-for="(labelList,index) in evaluatelabel" :key="index" @click="toggle($event)">{{labelList}}</span>
      </div>
      <textarea id="write" rows="10" v-model="evaluate" placeholder="请输入评价内容，最少20字"></textarea>
    </div>
    <div class="btn" @click="submit">发表评价</div>
  </div>
</template>

<script>
import {StarRating} from 'vue-rate-it'
import { Toast, Indicator } from 'mint-ui'
import qs from 'qs'
export default {
  name: 'evaluate',
  data () {
    return {
      ratingOne: '',
      ratingTwo: '',
      ratingThree: '',
      selectLabel: [],
      data: '',
      // 询价单名称
      projecttitle: '',
      // 雇佣人名称
      suppliername: '',
      // 准时率
      punctuality: '',
      punctualitypj: [],
      punctualitypjList: [],
      // 完成质量
      completion: '',
      completionpj: [],
      completionpjList: [],
      // 满意度
      satisfaction: '',
      satisfactionpj: [],
      satisfactionpjList: [],
      // 评价
      evaluate: '',
      evaluateList: '',
      evaluatelabel: []
    }
  },
  components: {
    StarRating
  },
  mounted () {
    console.log(this.$route.query.projectid)
    this.ratingOne = 5
    this.ratingTwo = 5
    this.ratingThree = 5
    this.initialize()
    // this.queryprojectorder()
    this.projecttitle = this.$route.query.projecttitle
    this.suppliername = this.$route.query.suppliername
    this.STATE.state.evaluateprojectid = this.$route.query.projectid
  },
  methods: {
    toggle: function ($event) {
      // let _this = this
      if (this.selectLabel.indexOf($event.currentTarget.innerHTML) !== -1) {
        var i = this.selectLabel.indexOf($event.currentTarget.innerHTML)
        this.selectLabel.splice(i, 1)
        $event.currentTarget.className = ''
        return
      } else {
        this.selectLabel.push($event.currentTarget.innerHTML)
        $event.currentTarget.className = 'select'
        return
      }
    },
    initialize: function () {
      let _this = this
      this.axios.get('url/work/project/appraiseLabel')
      .then(function (res) {
        console.log(res)
        _this.punctualitypjList = res.data[0]
        _this.completionpjList = res.data[1]
        _this.satisfactionpjList = res.data[2]
        _this.punctualityRate()
        _this.completionQuality()
        _this.satisfactionRate()
      })
    },
    punctualityRate () {
      let _this = this
      _this.punctualitypj = ''
      _this.punctuality = this.ratingOne
      _this.punctualitypj = _this.punctualitypjList[_this.punctuality]
      this.evaluateType()
    },
    completionQuality () {
      let _this = this
      _this.completionpj = ''
      _this.completion = this.ratingTwo
      _this.completionpj = _this.completionpjList[_this.completion]
      this.evaluateType()
    },
    satisfactionRate () {
      let _this = this
      _this.satisfactionpj = ''
      _this.satisfaction = this.ratingThree
      _this.satisfactionpj = _this.satisfactionpjList[_this.satisfaction]
      this.evaluateType()
    },
    evaluateType () {
      let _this = this
      _this.evaluateList = _this.punctualitypj.concat(_this.completionpj).concat(_this.satisfactionpj)
      if (_this.evaluateList != null) {
        _this.evaluatelabel = _this.evaluateList.split(',')
      }
    },
    submit () {
      let _this = this
      _this.evaluateList = ''
      if (this.selectLabel.length < 1) {
        Toast({
          message: '请选择评价标签',
          position: 'middle',
          duration: 1000
        })
      } else if (this.evaluate === '' || this.evaluate.length < 20 || this.evaluate.length > 500) {
        Toast({
          message: '评价内容请输入20至500字',
          position: 'middle',
          duration: 1000
        })
      } else {
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        this.axios({
          method: 'post',
          url: 'url/work/project/appraise',
          data: qs.stringify({
            projectId: this.$route.query.projectid,
            employerId: this.STATE.state.loginId,
            punctuality: _this.punctuality,
            quality: _this.completion,
            satisfaction: _this.satisfaction,
            note: _this.evaluate,
            label: _this.selectLabel.join(','),
            supplierId: this.$route.query.supplierId
          })
        }).then(function (res) {
          _this.data = res.data
          if (_this.data.success) {
            console.log('我进来了额')
            _this.$router.push('/project/evaluate/evaluateSuccess')
            // _this.$router.push({path: '/project/projectApplyPopup', query: { projectid: this.$route.query.projectid }})
            // _this.$router.push({path: '/project/evaluate/evaluateSuccess', query: { projectid: this.$route.query.projectid }})
            Indicator.close()
          } else {
            Indicator.close()
            Toast({
              message: _this.data.msg,
              position: 'middle',
              duration: 1000
            })
          }
        }).catch(function (response) {
          Indicator.close()
        })
      }
    }
  }
}
</script>

<style scoped>
.content{
  padding: 10px 18px;
}
.content .title h1{
  font-size: 15px;
}
.content .title p{
  font-size: 12px;
  color:#727272;
  display: inline-block;
}
.content .title p:nth-child(3){
  float: right;
}
.content .title p span{
  color:#108ee9;
}
.content .star{
  border: 1px solid #ccc;
  padding: 11px 15px;
  box-sizing: border-box;
  margin-top: 12px;
}
.content .star div{
  line-height: 35px;
}
.content .star span{
  display: inline-block;
  width: 80px;
}
.rating{
  display: inline-block;
  vertical-align: sub;
}
.content .label{
  margin: 5px 0;
}
.content .label span{
  display: inline-block;
  min-width: 50px;
  padding: 2px 10px;
  font-size: 12px;
  background-color: #f2f2f2;
  color: #989898;
  margin: 5px;
  -webkit-border-radiu:3px;
  -moz-border-radiu:3px;
  border-radius:3px;
  text-align: center;
  box-sizing: border-box;
}
.content .label .select{
  background-color: #1691ea;
  color: #fff;
}
#write{
  width: 100%;
  -webkit-border-radiu:5px;
  -moz-border-radiu:5px;
  border-radius:5px;
  border:1px solid #d6d6d6;
  margin-top: 10px;
  padding: 12px 15px;
  box-sizing: border-box;
  outline: none;
  resize: none;
  font-size: 12px;
}
.btn{
  margin-bottom: 70px;
  width: 100%;
  line-height: 40px;
  background-color: #108ee9;
  color: #fff;
  text-align: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// evaluate.vue?3fe64268